<template>
    <div :style=this.radar_style>
        <canvas :id="id"></canvas>
        <div v-if="is_showed">

            <div v-for="(value, key) in this.items[this.label]" :key="key">
                <v-chip 
                    class="ma-2"
                    :color="backgroundColor[background_color_index]"
                >
                    {{ value }}
                    
                </v-chip>
            </div>
        </div>
    </div>

</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'Chart',
        data: () => ({
            is_showed: false,
            background_color_index: -1,
            label: "",
            items: {
                "Programming Langauage": {"Python": "Python", "Java": "Java", "PHP": "PHP", "Shell": "Shell", "TypeScript": "TypeScript", "JavaScript": "JavaScript", "Groovy": "Groovy", "C": "C", "C#": "CS", "VB": "VB", "SQL": "SQL"},
                "Backend Framework": {"Flask": "Flask", "Django": "Django", "SpringBoot": "SpringBoot"},
                "Fontend Framework": {"Vue.js": "Vue.js"},
            },
            

        }),
        computed: {
            style() {
                let width = this.loggedIn ? '100%' : '400px'
                let height = this.loggedIn ? '1200px' : '400px'

                return { height, width }
            },
            radar_style() {
                let margin = 'auto'
                // let marginLeft = '25%'
                // let height = '450px'
                let width = '90%'
                // let border = 'solid'
                let display = 'flex'
                // let overflow = 'hidden'
                // let whiteSpace = 'nowrap'

                return { margin, width, display }
            },
        },
        created() {

        },
        props: [
            'id', 
            'width',
            'height',
            'type',
            'title',
            'labels',
            'data',
            'fill', 
            'backgroundColor', 
            'borderColor',
            'borderWidth'
        ],
        methods: {
            drawChart() {
                // console.log(this.items[0].a);

                var radar_chart = document.getElementById(this.id);
                var ctx = document.getElementById(this.id).getContext('2d');

                var chart = new Chart(ctx, {
                    type: this.type ? this.type : 'bar',
                    data: {
                        labels: this.labels,
                        datasets: [{
                            label: this.title,
                            data: this.data,
                            fill: this.fill,
                            backgroundColor: this.backgroundColor,
                            borderColor: this.borderColor,
                            borderWidth: this.borderWidth ? this.borderWidth : 1
                        }]
                    },
                    options: {
                        responsive: true,
                         legend: {
                            display: true,
                            labels: {
                                boxWidth: 20,
                                boxHeight: 2
                            }
                        },
                        elements: {
                            line: {
                                tension: 0,
                                borderWidth: 3
                            }
                        },
                        tooltips: {
                            callbacks: {
                                title: (tooltipItem, data) => data.labels[tooltipItem[0].index]
                            }
                        }
                    }
                });

                return { radar_chart, chart };
            },

            clickChart(radar_chart, chart) {
                var self = this;
           
                radar_chart.onclick = function(evt) {
                    var activePoints = chart.getElementsAtEvent(evt);

                    if (activePoints[0]) {
                        var chartData = activePoints[0]['_chart'].config.data;
                        var index = activePoints[0]['_index'];
                        var label = chartData.labels[index];
                        self.label = label;
                        
                        // var value = chartData.datasets[0].data[idx];
                        self.background_color_index = index;
                        this.style.marginLeft = '-25%';
                        self.is_showed = true;
                    }
                }
            }            
        },
        mounted() {
            var result = this.drawChart();
            this.clickChart(result['radar_chart'], result['chart']);
        }
    }
</script>

<style scoped>
    /* .row:after {
        content: "";
        display: table;
        clear: both;
    } */

    .row {
        overflow: hidden;
        white-space: nowrap;
    }
    /* #block_container {
        text-align:center;
    }

    #bloc1, #bloc2 {
        display:inline;
    } */
</style>
